import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map, tap, timeout } from "rxjs/operators";
import { environment } from "../../environments/environment";

@Injectable()
export class ArticLabPlanningService {
  
  defaultTimeout = 600000;
  
  constructor(private http: HttpClient) {
  }
  
  getExcelExportForBatchData(downloadType:string, jsonString: string) {
    let url = environment.BB_APG_SAMPLE_PROCESSING_URL + '/api/excel/download' ;
      let requestParam = new HttpParams().set('downloadType', downloadType).set('requestParam', jsonString);
    return this.http.get(url, { observe: 'response', responseType: 'blob', params: requestParam}).pipe(
      map((res) => {
        return {
          fileContent: new Blob([res.body], { type: res.headers.get('content-Type') }),
          filename: res.headers.get('filename')
        }
      })
      );
  }
  getBatchesForLab(labId: string): Observable<any> {
    let url = environment.BB_APG_SAMPLE_PROCESSING_URL + "covid19Batch/labplanning/list/" + labId;
    return this.http.get<any>(url).pipe(timeout(environment.defaultTimeout), tap(resp=>{resp.url='batches'}));
  }
  assignPlannedTagPlateToBatch(selectedLabId: string, mapToUpdatePlannedTagPlate: any) {
    let url = environment.BB_APG_SAMPLE_PROCESSING_URL + "covid19Batch/labplanning/planTagPlate/" + selectedLabId;
    return this.http.put<any>(url, mapToUpdatePlannedTagPlate).pipe(timeout(environment.defaultTimeout), tap( error => {
      error.url = url;
    }));
  }
}